import * as React from 'react';
import { useResizeObserver } from '~/Utils/Hooks/useResizeObserver';

export const useWrapDetection = (ref: React.RefObject<HTMLDivElement>): boolean => {
    const [isWrapped, setIsWrapped] = React.useState(false);
    const dimensions = useResizeObserver(ref);

    React.useLayoutEffect(() => {
        if (!ref.current || ref.current.children.length === 0) {
            return;
        }

        const firstChild = ref.current.children[0];
        const firstChildRect = firstChild.getBoundingClientRect();
        let wrapped = false;

        for (let i = 1; i < ref.current.children.length; i++) {
            const child = ref.current.children[i];
            const { top } = child.getBoundingClientRect();

            if (firstChildRect.bottom <= top) {
                wrapped = true;
                break;
            }
        }

        setIsWrapped(wrapped);
    }, [ref, dimensions]);

    return isWrapped;
};
